import React, { Component } from "react";
import { Link } from "react-router-dom";
import { setProduct } from "../../../store/actions";
import { registerGlanceView } from "../../../store/actions/analytics";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import QuickAddToCart from "../QuickAddToCart";
import { ReactComponent as Clock } from "../assets/alarm-clock.svg";
import {
  checkForStockWarningMessage,
  getOriginalProduct,
  getPrepTime,
  isOutOfStock,
} from "../Helpers";
import OutOfStock from "../OutOfStock";
import NotAvailable from "../NotAvailable";
import {
  getDiscountedPercentage,
  getNewPrice,
} from "../../../Helpers/promotions";
import dairyFreeIcon from "../../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../../ActionButton/assests/peanut-free.png";
import organicIcon from "../../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../../ActionButton/assests/leaf.png";
import veganIcon from "../../ActionButton/assests/vegan.png";
import glutenIcon from "../../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../../ActionButton/assests/dairy.png";
import eggIcon from "../../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../../ActionButton/assests/chilli.png";
import ProductTag from "../../ProductDetails/ProductTag";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

const styles = (theme) => ({
  root: {
    width: 345,
    marginLeft: 90,
  },
});

class ProductInList extends Component {
  render() {
    const {
      settings,
      language,
      cart,
      category_id,
      store,
      product,
      usedComponents,
    } = this.props;
    const real_price = getNewPrice(
      product,
      this.props.coupon,
      this.props.discounts,
      this.props.store.smart_promos,
    );

    const has_striked_price =
      product.striked_price && product.striked_price > this.props.product.price;

    const originalProduct = getOriginalProduct(
      product,
      category_id,
      store.categories,
    );
    const outOfStock = isOutOfStock(originalProduct, cart, usedComponents);
    const isDiscounted = product.price > real_price || has_striked_price;
    const tag = this.props.tags?.find((t) => t.id == this.props.product.tag);
    const currencyIcon = getCurrencyIcon(settings);
    return (
      <Link
        to={{
          pathname:
            (this.props.branch.branch && settings.is_branch_based_ordering) ||
            !settings.is_branch_based_ordering ||
            settings.branch_count === 1 ||
            product.hide_buy_button ||
            true
              ? `/product/${product.category}/${product.slug}`
              : "/select/branch",
          state: {
            pickupOnly: product.pickup_only,
            deliveryOnly: product.delivery_only,
          },
        }}
        replace={!!this.props.fromRecommendations}
        onClick={() => {
          let store_product = this.props.product;

          if (
            ((this.props.branch.branch ||
              this.props.settings.branch_count === 1) &&
              this.props.settings.is_branch_based_ordering) ||
            !this.props.settings.is_branch_based_ordering ||
            true
          ) {
            if (this.props.category_id !== this.props.product.category_id) {
              try {
                store_product = this.props.store.categories.find(
                  (category) => category.id === this.props.product.category_id,
                );
                if (this.props.product.parent) {
                  store_product = store_product.products
                    .find((parent) => parent.id === this.props.product.parent)
                    .children.find(
                      (product) => product.id === this.props.product.id,
                    );
                } else {
                  store_product = store_product.products.find(
                    (product) => product.id === this.props.product.id,
                  );
                }
              } catch (err) {
                store_product = this.props.product;
              }
            }
            this.props.setProduct(store_product);
          } else {
            if (settings.is_branch_based_ordering)
              if (
                !this.props.branch.branch &&
                this.props.settings.branch_count === 1
              ) {
                return;
              }
            this.props.setNextPage(
              `/product/${this.props.product.category}/${this.props.product.slug}`,
            );
          }
          if (this.props.fromRecommendations)
            this.props.registerGlanceView({
              type: "product_recommendation_click",
              source: this.props.fromCart
                ? "cart"
                : this.props.fromCheckout
                  ? "checkout"
                  : "product details",
            });
        }}
        style={{ color: "black" }}
      >
        <div
          style={
            language === "english"
              ? { marginLeft: !this.props.is_first ? "15px" : "" }
              : { marginRight: !this.props.is_first ? "15px" : "" }
          }
        >
          <div
            style={{
              background: `url(${
                this.props.product.photo_medium
                  ? this.props.product.photo_medium
                  : this.props.product.photo
              }) no-repeat center center`,
              borderRadius: 5,
              backgroundSize: this.props.product.stretch_photo
                ? settings?.fit_images_to_div
                  ? "100% 100%"
                  : "cover"
                : "contain",
              width: "150px",
              display: "block",
              cursor: "pointer",
              height: 150,
              minHeight: 150,
              position: "relative",
            }}
          >
            {this.props.product.tag && tag && (
              <ProductTag
                product={this.props.product}
                placement={tag?.placement}
                discount={Boolean(isDiscounted)}
              />
            )}

            {Boolean(isDiscounted) && (
              <div
                className="discount-sign"
                style={{
                  left: language !== "arabic" && 8,
                  right: language === "arabic" && 8,

                  backgroundColor:
                    this.props.discountTagColor || this.props.themeColor,
                  direction: language === "arabic" && "ltr",
                }}
              >
                {`${getDiscountedPercentage(
                  real_price,
                  (has_striked_price && product.striked_price) || product.price,
                )} %`}
              </div>
            )}
            {this.props.product.preparation_time > 0 &&
              this.props.product.type_of_product !== "service" &&
              this.props.product.show_prep_time &&
              settings.show_prep_times && (
                <div
                  style={{
                    color: this.props.themeColor,
                    background: "rgba(255, 255, 255, 0.85)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: "100%",
                    paddingTop: 5,
                    height: 30,
                    bottom: 0,
                    position: "absolute",
                  }}
                >
                  <Clock
                    className="mx-2"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  {getPrepTime(
                    this.props.product.preparation_time,
                    language,
                  )}{" "}
                </div>
              )}
            {this.props.product.duration > 0 &&
              this.props.product.type_of_product === "service" && (
                <div
                  style={{
                    color: this.props.themeColor,
                    background: "rgba(255, 255, 255, 0.85)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: "100%",
                    paddingTop: 5,
                    height: 30,
                    bottom: 0,
                    position: "absolute",
                  }}
                >
                  <Clock
                    className="mx-3"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  {getPrepTime(this.props.product.duration, language)}{" "}
                </div>
              )}
          </div>
          <p
            className={"mt-2 mb-0  cut-text-two-lines-grid-view ".concat(
              language == "english" ? "text-left pl-1" : "text-right pr-1",
            )}
            style={{
              direction: language == "english" ? "ltr" : "rtl",
              width: 150,
              height: 40,
              fontWeight: "bold",
              textDecoration:
                this.props.product.not_available && "line-through",
            }}
          >
            {checkForStockWarningMessage(
              this.props.product.show_warning_item_availability,
              this.props.product.inventory_on_hand,
              this.props.product.warning_item_availability_count,
              outOfStock,
              this.props.product.warning_item_availability_message_value,
              language,
              this.props.product.has_variants,
              this.props.product.type_of_product,
            )}
            {language == "english"
              ? this.props.product.name
              : this.props.product.ar_name}
          </p>
          {settings.show_nutrition_facts && (
            <div
              style={{
                height: 15,
              }}
              className={
                language == "english"
                  ? "text-left pl-1  mb-3"
                  : "text-right pr-1  mb-3"
              }
            >
              {product.dietary_restrictions?.includes("Dairy free") && (
                <img
                  src={dairyFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Gluten free") && (
                <img
                  src={glutenFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Sugar free") && (
                <img
                  src={sugarFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Nut free") && (
                <img
                  src={nutFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Vegan") && (
                <img
                  src={veganIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Vegetarian") && (
                <img
                  src={vegetarianIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions?.includes("Organic") && (
                <img
                  src={organicIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {product.dietary_restrictions
                ?.split(",")
                .map((r) => r.trim())
                .includes("Gluten") &&
                !product.dietary_restrictions
                  ?.split(",")
                  .map((r) => r.trim())
                  .includes("Gluten free") && (
                  <img
                    src={glutenIcon}
                    style={{ marginRight: 4, height: 18, width: 18 }}
                  />
                )}

              {product.dietary_restrictions?.includes("Nuts/Sesame") && (
                <img
                  src={nutsSesameIcon}
                  style={{ marginRight: 4, height: 21, width: 21 }}
                />
              )}

              {product.dietary_restrictions?.includes("Dairy") && (
                <img
                  src={dairyIcon}
                  style={{ marginRight: 4, height: 21, width: 21 }}
                />
              )}

              {product.dietary_restrictions?.includes("Egg") && (
                <img
                  src={eggIcon}
                  style={{ marginRight: 4, height: 21, width: 21 }}
                />
              )}

              {product.dietary_restrictions?.includes("Seafood/Shellfish") && (
                <img
                  src={seafoodShellfishIcon}
                  style={{ marginRight: 4, height: 21, width: 21 }}
                />
              )}

              {product.dietary_restrictions?.includes("Chilli") && (
                <img
                  src={chilliIcon}
                  style={{ marginRight: 4, height: 21, width: 21 }}
                />
              )}
            </div>
          )}
          <p
            className={"".concat(
              language == "english" ? "text-left pl-1" : "text-right pr-1 ",
            )}
            style={{
              fontSize: "0.8rem",
              color: this.props.themeColor,
            }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {!this.props.product.hide_buy_button ? (
              <div
                style={{ fontSize: 14, fontWeight: "bold" }}
                className={currencyIcon}
              >
                {settings.show_prices ? (
                  this.props.product.price ? (
                    this.props.product.price === real_price &&
                    !has_striked_price ? (
                      `${this.props.product.price.toFixed(
                        settings.currency_decimals,
                      )} ${
                        language == "english"
                          ? settings.currency_english
                          : settings.currency_local
                      }`
                    ) : (
                      <span>
                        <span
                          className={currencyIcon ? "" : "mx-2"}
                          style={{
                            textDecoration: "line-through",
                            fontWeight: "100",
                          }}
                        >
                          {`${
                            has_striked_price
                              ? this.props.product.striked_price.toFixed(
                                  settings.currency_decimals,
                                )
                              : this.props.product.price.toFixed(
                                  settings.currency_decimals,
                                )
                          } ${
                            language == "english"
                              ? settings.currency_english
                              : settings.currency_local
                          }`}
                        </span>
                        <span className={currencyIcon}>
                          {`${real_price.toFixed(settings.currency_decimals)} ${
                            language == "english"
                              ? settings.currency_english
                              : settings.currency_local
                          }`}
                        </span>
                      </span>
                    )
                  ) : language == "english" ? (
                    "Price on selection"
                  ) : (
                    "السعر عند الاختيار"
                  )
                ) : (
                  ""
                )}
              </div>
            ) : null}
          </p>

          {settings.enable_quick_add_to_cart &&
            !this.props.product.hide_buy_button &&
            !outOfStock &&
            !this.props.product.not_available &&
            this.props.product.show_quick_add_to_cart &&
            !this.props.settings.is_menu && (
              <div className="text-center">
                <QuickAddToCart
                  fromCheckout={this.props.fromCheckout}
                  fromRecommendations={this.props.fromRecommendations}
                  product={originalProduct}
                />
              </div>
            )}
          {outOfStock && (
            <OutOfStock type_of_product={this.props.product.type_of_product} />
          )}
          {this.props.product.not_available && !outOfStock && <NotAvailable />}
        </div>
      </Link>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    themeColor: state.store.store.settings.dark,
    discountTagColor: state.store.store.settings.discount_tag_color,
    branch: state.branch,
    coupon: state.cart.promos,
    discounts: state.cart.discounts,
    store: state.store.store,
    cart: state.cart.cart,
    usedComponents: state.store.used_components,
    tags: state.store.store.tags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (product) => dispatch(setProduct(product)),
    setNextPage: (nextPage) =>
      dispatch({ type: "SET_NEXT_PAGE", payload: nextPage }),
    registerGlanceView: (data) => dispatch(registerGlanceView(data)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ProductInList));
